import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { tanimlarApi } from '../services/api';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const token = () => localStorage.getItem('token');
const headers = () => ({ Authorization: `Bearer ${token()}` });

const YIL = new Date().getFullYear();
const AYLAR = ['', 'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
               'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

export default function ZiyaretRaporlari() {
  const [kayitlar,   setKayitlar]   = useState<any[]>([]);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [filtre,     setFiltre]     = useState({ yil: YIL, isletme_id: '' });

  useEffect(() => {
    tanimlarApi.isletmelerListesi(false).then(r => setIsletmeler(r.data));
  }, []);

  useEffect(() => { yukle(); }, [filtre]);

  const yukle = () => {
    const p: any = { yil: filtre.yil };
    if (filtre.isletme_id) p.isletme_id = filtre.isletme_id;
    axios.get(`${API}/api/ziyaret/`, { headers: headers(), params: p })
      .then(r => setKayitlar(r.data)).catch(() => setKayitlar([]));
  };

  // İşletme bazında özet
  const isletmeOzet = kayitlar.reduce((acc: any, k) => {
    const key = k.isletme_id;
    if (!acc[key]) acc[key] = { isletme_ad: k.isletme_ad, isletme_kod: k.isletme_kod, sayi: 0, sure: 0 };
    acc[key].sayi++;
    acc[key].sure += k.sure_dk || 0;
    return acc;
  }, {});

  // Ay bazında özet
  const ayOzet = kayitlar.reduce((acc: any, k) => {
    const ay = new Date(k.baslangic).getMonth() + 1;
    if (!acc[ay]) acc[ay] = { ay, sayi: 0, sure: 0 };
    acc[ay].sayi++;
    acc[ay].sure += k.sure_dk || 0;
    return acc;
  }, {});

  // Konu bazında özet
  const konuOzet = kayitlar.reduce((acc: any, k) => {
    const konu = k.konu_ad || 'Belirtilmemiş';
    if (!acc[konu]) acc[konu] = { konu, sayi: 0 };
    acc[konu].sayi++;
    return acc;
  }, {});

  const sureFmt = (dk: number) => {
    if (!dk) return '-';
    const s = Math.floor(dk / 60);
    const d = dk % 60;
    return s > 0 ? `${s}s ${d}dk` : `${d}dk`;
  };

  const isletmeOzetListe = Object.values(isletmeOzet).sort((a: any, b: any) => b.sayi - a.sayi);
  const ayOzetListe = Object.values(ayOzet).sort((a: any, b: any) => (a as any).ay - (b as any).ay);
  const konuOzetListe = Object.values(konuOzet).sort((a: any, b: any) => b.sayi - a.sayi);

  const toplamSure = kayitlar.reduce((s, k) => s + (k.sure_dk || 0), 0);

  return (
    <div>
      <div className="page-header">
        <h1>📊 Ziyaret Raporları</h1>
        <p>Yönetici ziyaret istatistikleri ve analizleri</p>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div className="toolbar">
          <div style={{ display: 'flex', gap: 8 }}>
            <input type="number" className="search-input" style={{ width: 90 }} value={filtre.yil}
              onChange={e => setFiltre({ ...filtre, yil: Number(e.target.value) })} placeholder="Yıl" />
            <select className="search-input" style={{ width: 210 }} value={filtre.isletme_id}
              onChange={e => setFiltre({ ...filtre, isletme_id: e.target.value })}>
              <option value="">Tüm İşletmeler</option>
              {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
            </select>
          </div>
        </div>
      </div>

      <div className="stats-grid">
        <div className="stat-card"><div className="stat-icon">📋</div><div><div className="stat-value">{kayitlar.length}</div><div className="stat-label">Toplam Ziyaret</div></div></div>
        <div className="stat-card"><div className="stat-icon">🏢</div><div><div className="stat-value">{isletmeOzetListe.length}</div><div className="stat-label">Ziyaret Edilen İşletme</div></div></div>
        <div className="stat-card"><div className="stat-icon">⏱️</div><div><div className="stat-value">{sureFmt(toplamSure)}</div><div className="stat-label">Toplam Süre</div></div></div>
        <div className="stat-card"><div className="stat-icon">📅</div><div><div className="stat-value">{kayitlar.length > 0 ? Math.round(toplamSure / kayitlar.length) + 'dk' : '-'}</div><div className="stat-label">Ortalama Süre</div></div></div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        {/* İşletme bazında */}
        <div className="card">
          <h3 style={{ margin: '0 0 12px', fontSize: 14, color: '#1a5276' }}>🏢 İşletme Bazında Ziyaretler</h3>
          <table style={{ width: '100%', fontSize: 13 }}>
            <thead><tr><th>İşletme</th><th>Ziyaret</th><th>Toplam Süre</th></tr></thead>
            <tbody>
              {isletmeOzetListe.map((r: any) => (
                <tr key={r.isletme_kod}>
                  <td><strong>{r.isletme_kod}</strong> {r.isletme_ad}</td>
                  <td style={{ textAlign: 'center' }}>{r.sayi}</td>
                  <td style={{ textAlign: 'center' }}>{sureFmt(r.sure)}</td>
                </tr>
              ))}
              {isletmeOzetListe.length === 0 && <tr><td colSpan={3} style={{ textAlign: 'center', color: '#999', padding: 12 }}>Veri yok</td></tr>}
            </tbody>
          </table>
        </div>

        {/* Ay bazında */}
        <div className="card">
          <h3 style={{ margin: '0 0 12px', fontSize: 14, color: '#1a5276' }}>📅 Aylık Ziyaret Dağılımı ({filtre.yil})</h3>
          <table style={{ width: '100%', fontSize: 13 }}>
            <thead><tr><th>Ay</th><th>Ziyaret</th><th>Toplam Süre</th></tr></thead>
            <tbody>
              {ayOzetListe.map((r: any) => (
                <tr key={r.ay}>
                  <td>{AYLAR[r.ay]}</td>
                  <td style={{ textAlign: 'center' }}>{r.sayi}</td>
                  <td style={{ textAlign: 'center' }}>{sureFmt(r.sure)}</td>
                </tr>
              ))}
              {ayOzetListe.length === 0 && <tr><td colSpan={3} style={{ textAlign: 'center', color: '#999', padding: 12 }}>Veri yok</td></tr>}
            </tbody>
          </table>
        </div>

        {/* Konu bazında */}
        <div className="card" style={{ gridColumn: '1 / -1' }}>
          <h3 style={{ margin: '0 0 12px', fontSize: 14, color: '#1a5276' }}>📌 Ziyaret Konusu Dağılımı</h3>
          <table style={{ width: '100%', fontSize: 13 }}>
            <thead><tr><th>Konu</th><th>Ziyaret Sayısı</th><th>Oran</th></tr></thead>
            <tbody>
              {konuOzetListe.map((r: any) => (
                <tr key={r.konu}>
                  <td>{r.konu}</td>
                  <td style={{ textAlign: 'center' }}>{r.sayi}</td>
                  <td style={{ textAlign: 'center' }}>
                    {kayitlar.length > 0 ? `%${Math.round(r.sayi / kayitlar.length * 100)}` : '-'}
                  </td>
                </tr>
              ))}
              {konuOzetListe.length === 0 && <tr><td colSpan={3} style={{ textAlign: 'center', color: '#999', padding: 12 }}>Veri yok</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
